export const AMENITIES = [
    '24-Hour Front Desk',
    'Air conditioning (free / for fee)',
    'ATM / cash machine',
    'Babysitter services (free / for fee)',
    'Balcony',
    'Bar',
    'Barbecue (free / for fee)',
    'Bath & bathroom',
    'Bathroom  Amenities (free / for fee)',
    'Beach',
    'Beach services (free / for fee)',
    'Beauty Salon (free / for fee)',
    'Bicycle rentals',
    'Boat Rental',
    'Breakfast (free / for fee)',
    'Business services (free / for fee)',
    'Cafe',
    'Car rentals',
    'Casino',
    'Catering & Banquet facilities',
    'Children services (free / for fee)',
    'Computer / Laptop',
    'Concierge / Porterage services',
    'Conference facilities',
    'Copy and Fax services (free / for fee)',
    'Courts (free / for fee)',
    'Currency exchange',
    'Disabled facilities',
    'Entertainment (free / for fee)',
    'Excursion/tour desk (free / for fee)',
    'Fan',
    'Fireplace',
    'Fitness (free / for fee)',
    'Fridge (free / for fee)',
    'Garage (free / for fee)',
    'Garden',
    'Golf (free / for fee)',
    'Guide',
    'Gym (free / for fee)',
    'Hair dryer (free / for fee)',
    'Hairdresser (free / for fee)',
    'Heating',
    'Housekeeping / Laundry services (free / for fee)',
    'Indoor Pool (free / for fee)',
    'Internet access (free / for fee)',
    'Iron & Ironing Board (free / for fee)',
    'Jacuzzi',
    'Kitchen (free / for fee)',
    'Library',
    'Lounge (free / for fee)',
    'Massage (free / for fee)',
    'Medical services',
    'Meeting rooms & facilities (free / for fee)',
    'Mini-Bar',
    'No-smoking',
    'Non-alcohol',
    'Non-local cuisine',
    'Parking (free / for fee)',
    'Pets allowed (free / for fee)',
    'Pool (free / for fee)',
    'Pool Bar',
    'Postal Service',
    'Pub',
    'Restaurant',
    'Room service (free / for fee)',
    'Safari',
    'Safe (free / for fee)',
    'Sauna / Turkish Bath (free / for fee)',
    'Security services',
    'Shop',
    'Smoking area',
    'Solarium (free / for fee)',
    'Spa / Health Club (free / for fee)',
    'Sport',
    'Storage',
    'Telephone (free / for fee)',
    'Terrace',
    'Theatre',
    'Transfer / Shuttle services (free / for fee)',
    'TV (free / for fee)',
    'Vegan',
    'Vegetarian',
    'Water sports',
    'Wedding services',
    'Wi-Fi (free / for fee)',
    'Winter sports'
  ];


// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/pages/hotel-detail/hotel.ts